export const TEXTS = {
  TITLE: 'Выбор адресов',
  SEARCH_PLACEHOLDER: 'Поиск по адресам',
  SELECT_ALL: 'Выбрать все',
  RESET: 'Сбросить',
  CREATE: 'Создать',
  BACK: 'Назад',
  EMPTY: 'Адреса не найдены',
  EMPTY_FILTERED: 'По этому запросу адреса не найдены',
};
